module.exports = __webpack_public_path__ + "img/50d@2x.f5dcdd1b.svg";